



























































































import { defineComponent, computed, ref, watch, getCurrentInstance, toRef, toRefs, Ref } from '@vue/composition-api';
import { ErrorCircleIcon, UserIcon, ChevronRightIcon } from 'tdesign-icons-vue';

import SelectFilePath from '@/renderer/components/dialog/SelectFilePath/index.vue';

import { getFileIcon } from '@/renderer/scripts/utils/tools/index';
import guideStepHandler from '@/renderer/components/GuideAndHelp/composition/guideStepHandler';
import stencilHandler, { ListItem } from '@/renderer/components/dialog/SelectFilePath/compositions/stencilHandler';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import createCollaborationHandler from '../compositions/createCollaborationHandler';
export default defineComponent({
  name: 'MobileCreateCollaboration',
  components: {
    SelectFilePath,
    ErrorCircleIcon,
    UserIcon,
    ChevronRightIcon,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    importPath: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const { groupNameMaxLength } = ConstantConfig;
    const showMoreStencil = ref(false);
    const { stencilData, initSelectedList, methods: stencilMethods } = stencilHandler('group');

    const { methods: guideStepMethods } = guideStepHandler();

    const { formData, createLoading, rules, methods: createMethods } = createCollaborationHandler();

    const selectStencilArr: Ref<ListItem[]> = ref([]);
    const selectedList = computed(() => {
      let composeSelectedList = stencilData.stencilList.reduce(
        (acc, cur) => {
          const existSameId = acc.findIndex(item => item.id === cur.id);
          if (existSameId !== -1) {
            acc[existSameId].checked = true;
          } else {
            acc.push(cur);
          }
          return acc;
        },
        [...selectStencilArr.value],
      );
      // id去重操作
      composeSelectedList = Array.from(
        composeSelectedList.reduce((map, item) => map.set(item.id, item), new Map()).values(),
      );
      return composeSelectedList.filter(item => item.checked === true);
    });

    const disabledSubmit = computed(() => !formData.name);

    const methods = {
      async onSubmit(type?: 'invite' | string) {
        // 如果正在导入中｜正在创建中直接return，避免重复创建
        if (props.loading || createLoading.value) return;
        const validate = await (context.refs.form as any).validate();
        if (typeof validate === 'boolean' && validate) {
          createMethods.onCreate(selectedList.value).then(async code => {
            if (code !== -1) {
              // 查看新手引导是否有对应数据，如果没有，对其进行对应新建协作的更新
              guideStepMethods.monitoringStepsDone('collaborationSpace', 0);
              // methods.onClose(); // 导入成功后，手动赋值关闭，避免提前清空文件路径
              context.emit('success', code, type);
            }
          });
        }
      },
      onClose() {
        innerShow.value = false;
        context.emit('showImport', 'create', false); // 关闭创建时，清空已有的文件路径
      },
      onShowMoreStencil() {
        showMoreStencil.value = true;
      },
      showImportDialog() {
        context.emit('showImport', 'import', true);
      },
      onClickStencil(item: ListItem) {
        item.checked = !item.checked;
      },
      confirmSelectStencil(params: []) {
        selectStencilArr.value = params;
        stencilData.stencilList = stencilData.stencilList.map(item1 => {
          // 判断是否已勾选
          const selectData = selectStencilArr.value.find(item2 => item2.id === item1.id);
          return { ...item1, checked: !!selectData };
        });
      },
    };
    watch(innerShow, val => {
      if (val) {
        createMethods.initData();
        // 重置selected为[];
        initSelectedList.value = [];
        selectStencilArr.value = [];
        stencilData.stencilList = [];
        stencilMethods.stencilPullList('all');
      }
    });
    return {
      rules,
      disabledSubmit,
      innerShow,
      formData,
      groupNameMaxLength,

      // 选择模板
      getFileIcon,
      showMoreStencil,
      selectedList,
      ...toRefs(stencilData),

      ...methods,
    };
  },
});
